import React, { useState } from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
} from "react-router-dom";

import Home from "./Forms/Home";
import Inventory from "./Forms/Inventory";
import Category from "./Forms/Category";
import Products from "./Forms/Products";
import Orders from "./Forms/Orders";
import Reports from "./Forms/Reports";

import "./App.css";
import NavBar from "./components/NavBar";
import Dashboard from "./Forms/Dashboard";
import Login from "./components/Login";   // ✅ import new Login component

function App() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("authToken"));

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setLoggedIn(false);
  };

  return (
    <Router>
      <div className="ticker">
        <div className="ticker__content">
          Welcome to FiveStarChicken POS! | Contact: support@fivestarchicken.com
          | About: Fast, Reliable, Delicious!
        </div>
      </div>
       {!loggedIn ? (
        <Login onLoginSuccess={() => setLoggedIn(true)} />

      ) : (
        <div>
          <NavBar onLogout={handleLogout} />
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/home" element={<Home />} />

              <Route path="/inventory" element={<Inventory />} />
              <Route path="/category" element={<Category />} />
              <Route path="/products" element={<Products />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/reports" element={<Reports />} />
            </Routes>
          </div>
          <Footer />
        </div>
      ) }
  
    </Router>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div>
        <b>Email:</b> support@fivestarchicken.com | <b>Name:</b> FiveStarChicken
        POS | <b>About:</b> Fast, Reliable, Delicious!
      </div>
      <div>
        © {new Date().getFullYear()} FiveStarChicken. All rights reserved.
      </div>
    </footer>
  );
}

export default App;